var map = {
	"./align-center.svg": 2042,
	"./align-left.svg": 1337,
	"./align-right.svg": 4388,
	"./bold.svg": 8775,
	"./bulleted-list.svg": 886,
	"./heading-one.svg": 3271,
	"./heading-two.svg": 5719,
	"./italic.svg": 9426,
	"./numbered-list.svg": 5546,
	"./underlined.svg": 1108
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4920;